import React from 'react';

const ScoreCountDaily = ({ score }) => {
    const outOf5 = parseFloat(score);
    const fullStars = Math.round(outOf5);
    const emptyStars = 5 - fullStars;

    // Color based on score
    const getColor = () => {

        if(outOf5 > 4){
            return 'text-purple-400';
        }
        if(outOf5 > 3){
            return 'text-green-400';
        }
        if(outOf5 > 2){
            return 'text-yellow-400';
        }
        if(outOf5 > 1){
            return 'text-orange-400';
        }
        return 'text-red-400';
    };

    return (
        <div className="flex flex-col items-center gap-1">
            <div className="flex flex-col-reverse items-center gap-0.5">
                {/* Full stars */}
                {[...Array(fullStars)].map((_, i) => (
                    <svg key={`full-${i}`} className={`w-3 h-3 sm:w-4 sm:h-4 ${getColor()}`} fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                ))}
                
                {/* Empty stars */}
                {[...Array(emptyStars)].map((_, i) => (
                    <svg key={`empty-${i}`} className="w-3 h-3 sm:w-4 sm:h-4 text-custom-charcoal" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                ))}
            </div>
            {/* <span className={`text-xs font-medium ${getColor()}`}>
                {outOf5.toFixed(1)}
            </span> */}
        </div>
    );
};

export default ScoreCountDaily;
